import { createFileRoute } from '@tanstack/react-router'
import { Form } from 'antd'
import React from 'react'
import { CampaignWhatsappSection } from '../campaign/components/settings/campaign-whatsapp-section'
import { useCampaign } from '../campaign/hooks'
import { useMessageTemplates } from '../campaign/message-template-hooks'
import { usePhoneNumbers } from '../whatsapp-business-account/phone-number-hooks'
import { useWhatsappBusinessAccounts } from '../whatsapp-business-account-hooks'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/whatsapp')({
    component: CampaignSettingsWhatsapp,
})

function CampaignSettingsWhatsapp() {
    const { campaignId } = Route.useParams()
    const { data: campaign } = useCampaign(campaignId)
    const form = Form.useFormInstance()
    const selectedWhatsappBusinessAccountId = Form.useWatch('whatsappBusinessAccountId', form)
    const accountsQuery = useWhatsappBusinessAccounts({
        enabled: true,
    })
    const phoneNumbersQuery = usePhoneNumbers(selectedWhatsappBusinessAccountId)
    const startTemplatesQuery = useMessageTemplates({
        enabled: !!selectedWhatsappBusinessAccountId,
        preservePreviousData: false,
        query: {
            size: 100,
            sort: '-created_at',
            filters: {
                purpose: ['start'],
                whatsappBusinessAccountId: selectedWhatsappBusinessAccountId
                    ? [selectedWhatsappBusinessAccountId]
                    : undefined,
            },
        },
    })
    const recontactTemplatesQuery = useMessageTemplates({
        enabled: !!selectedWhatsappBusinessAccountId,
        preservePreviousData: false,
        query: {
            size: 100,
            sort: '-created_at',
            filters: {
                purpose: ['recontact'],
                whatsappBusinessAccountId: selectedWhatsappBusinessAccountId
                    ? [selectedWhatsappBusinessAccountId]
                    : undefined,
            },
        },
    })
    return (
        <CampaignWhatsappSection
            accounts={accountsQuery.data || []}
            accountsLoading={accountsQuery.isLoading}
            phoneNumbers={phoneNumbersQuery.data?.data || []}
            phoneNumbersLoading={phoneNumbersQuery.isLoading}
            selectedWhatsappBusinessAccountId={selectedWhatsappBusinessAccountId}
            startTemplates={startTemplatesQuery.data?.data || []}
            startTemplatesLoading={startTemplatesQuery.isLoading}
            recontactTemplates={recontactTemplatesQuery.data?.data || []}
            recontactTemplatesLoading={recontactTemplatesQuery.isLoading}
            website={campaign?.website}
            onWhatsappBusinessAccountChange={() => {
                form.setFieldValue('phoneNumberId', null)
                form.setFieldValue('startMessageTemplateId', null)
                form.setFieldValue('recontactSchedule', [])
            }}
        />
    )
}
